import React from 'react';
import ReactGA from 'react-ga';
import landingMhaNav from '../../../assets/images/landingMhaNav.png';
import megaphoneIllustration from '../../../assets/images/campusDiveConstructionMegaphone.svg';
import ProjectShowcaseCard from '../../../components/cards/homeCards/projectShowcaseCard';
import showcaseCardStyles from '../../../components/cards/homeCards/projectShowcaseCard.module.scss';
import CaseStudyComingSoonBanner from '../../../components/caseStudyComingSoonBanner/CaseStudyComingSoonBanner';
import PortfolioOverviewSection from '../../../components/portfolioOverviewSection/PortfolioOverviewSection';
import style from './mha.module.scss';

// Figma 2199:16974 — MHA preview (replace placeholder client URL if needed)
const MHA_WEBSITE_URL = 'https://www.mnhospitals.org/';
const EMAIL_MORE_INFO_HREF =
  'mailto:kbermangestring@gmail.com?subject=MHA%20navigation%20case%20study';

const MHA_HERO_TAGS = [
  'Product Design',
  'UI Design',
  'User Research',
  'UX Design',
  'Click Testing',
  'Information Architecture',
  'Navigation',
  'Internal Tools',
  'Health Tech',
];

const MHA_OVERVIEW_COLUMNS = [
  { label: 'Timeline', value: '2 months' },
  {
    label: 'My role',
    lines: ['UX Designer', 'UX Researcher', 'UI Designer'],
  },
  {
    label: 'Team',
    itemsSingleLine: true,
    items: [
      'UX Designer',
      'Product Manager',
      'Project Manager',
      'Engineering Lead',
      '3 Engineers',
    ],
  },
  {
    label: 'Scope',
    wide: true,
    items: [
      'Evaluated a shift from a legacy top navigation to new nested side navigation pattern',
      'Conducted user research click-testing to validate usability',
      'Redesign UI for increased accessibility introducing new nomenclature and icons',
    ],
  },
];

function Mha() {
  React.useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <main className={style.mhaContainer}>
      <section className={style.mhaHeroShowcase} aria-label="Project introduction">
        <ProjectShowcaseCard
          tags={MHA_HERO_TAGS}
          tagBarClassName={style.mhaHeroTagBar}
          title="Re-Architecting Navigation to Critical Healthcare Systems"
          subhead="Redesigning structure and UI for side navigation to healthcare portals"
          imageSrc={landingMhaNav}
          imageAlt="Desktop mockup of a healthcare member portal with navigation and dashboard"
          to={MHA_WEBSITE_URL}
          ctaLabel="Go To MHA Website"
          mediaClassName={showcaseCardStyles.mediaWide}
          //tagRowBreakBeforeIndex={3}
          titleAs="h1"
          titlePosition="above"
        />
      </section>

      <PortfolioOverviewSection columns={MHA_OVERVIEW_COLUMNS} bulleted />

      <CaseStudyComingSoonBanner
        title="Case Study Coming Soon"
        imageSrc={megaphoneIllustration}
        ctaHref={EMAIL_MORE_INFO_HREF}
        ctaLabel="Email me for more information"
      >
        <p>
          This case study is being updated and will be coming to my portfolio soon. If you are
          interested in learning more about this project, please email me directly for a pdf or more
          information.
        </p>
      </CaseStudyComingSoonBanner>
    </main>
  );
}

export default Mha;
